module.exports = __webpack_public_path__ + "static/bg02-eb63681a252bc2a6ed6f4e012703b81a.jpg";